





































































































import { computed, defineComponent, onUnmounted, Ref, ref, watch } from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import midasHandler from '@/renderer/components/teamPay/compositions/midasHandler';

// 引入工具类
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { getDataFromUrl } from '@/renderer/scripts/utils/download/index';
import user from '@/renderer/scripts/utils/user';
import tips from '@/renderer/scripts/utils/tips';
import { switchOrg } from '@/renderer/scripts/utils/user/userSwitchOrg';
import smh, { SMH } from '@/renderer/scripts/smh';
import meeting from '@/renderer/scripts/utils/meeting';
import { getOfficialWebsiteUrl } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { transformErrorForSerialization } from '@/common/tools';
import { IS_DEV, IS_TEST, IS_BROWSER } from '@/common/constant/platform';
import { CONSTANT_URL } from '@/renderer/scripts/http';

import '@/renderer/assets/images/Icon/svg/close.svg';
import '@/renderer/assets/images/Icon/svg/team-medal.svg';
import '@/renderer/assets/images/Icon/svg/team-space.svg';
import '@/renderer/assets/images/Icon/svg/team-person.svg';
import '@/renderer/assets/images/Icon/svg/team-group.svg';
import '@/renderer/assets/images/Icon/svg/team-permission.svg';
import '@/renderer/assets/images/Icon/svg/team-cooperation.svg';
import '@/renderer/assets/images/Icon/svg/team-version.svg';
import '@/renderer/assets/images/Icon/svg/team-linkmanage.svg';
import '@/renderer/assets/images/Icon/svg/team-watermark.svg';
import '@/renderer/assets/images/Icon/svg/team-share.svg';
import '@/renderer/assets/images/Icon/svg/team-log.svg';
import '@/renderer/assets/images/Icon/svg/wechatPay.svg';
import '@/renderer/assets/images/Icon/svg/successPay.svg';

const QRCode = require('qrcode');

export default defineComponent({
  components: {
    UserIcon,
    BaseIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { openid, pf, aid, getAid, queryOrder, successPay, purchaseOrgId } = midasHandler();
    const vm = context.root;
    const store = vm.$store;
    const nowDebug = !!(IS_DEV || IS_TEST);
    const loading = ref(true);
    const teamIntroduces = [
      {
        type: 'team-space',
        descript: i18n_t('1T空间'),
      },
      {
        type: 'team-person',
        descript: i18n_t('20人团队'),
      },
      {
        type: 'team-group',
        descript: i18n_t('300个群组'),
      },
      {
        type: 'team-permission',
        descript: i18n_t('4级权限管理'),
      },
      {
        type: 'team-cooperation',
        descript: i18n_t('实时协作实况'),
      },
      {
        type: 'team-version',
        descript: i18n_t('历史版本恢复'),
      },
      {
        type: 'team-linkmanage',
        descript: i18n_t('安全外链管理'),
      },
      {
        type: 'team-watermark',
        descript: i18n_t('公司定制水印'),
      },
      {
        type: 'team-share',
        descript: i18n_t('企业空间共享'),
      },
      {
        type: 'team-log',
        descript: i18n_t('团队操作日志'),
      },
    ];
    const url = getOfficialWebsiteUrl();
    const baseInfo = computed(() => {
      const obj = {
        nickName: '',
        avatar: '',
        editionFlag: '',
        time: '',
        phoneNumber: '',
      };
      obj.nickName = store.getters.userBaseInfo.nickname;
      const { avatar } = store.getters.userBaseInfo;
      if (avatar) {
        obj.avatar = avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
      }
      obj.time = store.getters.expireTime?.split(' ')[0];
      obj.editionFlag = store.getters.editionFlag === 'personal' ? i18n_t('个人版') : i18n_t('团队版');
      const str = store.getters.userBaseInfo.phoneNumber;
      obj.phoneNumber = `${str.substr(0, 3)}****${str.substr(7)}`;
      return obj;
    });
    const products = ref<any[]>([]);
    const midasH5 = ref('');
    const selectedProduct: Ref<any> = ref();
    let queryOrderTimer: number | undefined;
    const qrCodeLoading = ref(false);
    const methods = {
      changeProduct(item: any, index: Number) {
        selectedProduct.value = item;
        products.value.forEach((pro, i) => {
          pro.isActive = i === index;
        });
      },
      // 绘制二维码
      drawQRCode(url: string) {
        const canvas = document.getElementById('qrCode');
        QRCode.toCanvas(
          canvas,
          url,
          {
            width: 160,
            height: 160,
            margin: 5,
          },
          (error: any) => {
            if (error) logger.ui.error(i18n_t('绘制二维码失败'), transformErrorForSerialization(error));
            else {
              qrCodeLoading.value = false;
            }
          },
        );
      },
      // 获取商品数据
      async getProducts() {
        qrCodeLoading.value = true;
        const res: any = await getDataFromUrl(`${url}/midas/setting${nowDebug ? '?beta=1' : ''}`);
        loading.value = false;
        products.value = res.common;
        products.value.forEach((pro, i) => {
          if (i === 0) {
            pro.isActive = true;
            selectedProduct.value = pro;
          } else {
            pro.isActive = false;
          }
        });
      },
      closeTeamPay() {
        store.commit('setTeamPay', {
          show: false,
        });
      },
      onMeetSidebarPositionChange(event: any) {
        if (event.position === 2 && props.show) {
          // store.commit('setMobileStyle', true);
          checkIfMobileStyle();
          methods.closeTeamPay();
        }
      },
      async getQrCode() {
        // 先获取订单号
        await getAid(store.getters.teamPay.isNew, selectedProduct.value.productid, {
          openid: openid.value,
          pf: 'desktop_m_guest-pc-webpay-web',
          platform: IS_BROWSER ? 'h5' : 'pc',
        });
        const payUrl = `${url}/midas/midasPay?aid=${aid.value}&openid=${openid.value}&productid=${
          selectedProduct.value.productid
        }${nowDebug ? '&beta=1' : ''}`;
        const res: any = await getDataFromUrl(payUrl);
        logger.ui(`[purchase] ${res.url}`);
        // midasH5.value = `http://tools.3g.qq.com/qrcode?width=130&height=130&margin=10&charset=UTF-8&errorCorrection=L&format=PNG&content=${content}`;
        methods.drawQRCode(res.url);
      },
      async initData() {
        await methods.getProducts();
        await methods.getQrCode();
        queryOrderTimer = window.setInterval(async () => {
          await queryOrder(aid.value);
        }, 2000);
      },
      // 切换团队版(切换到团队版的企业里)
      async changeOrg() {
        methods.closeTeamPay();
        try {
          // 获取新企业信息
          const orgId = purchaseOrgId.value;
          const res = await smh.userAPI.getUserOrg();
          const orgList = res.data;
          const newOrg = orgList.find(org => org.id === orgId);
          if (!newOrg) {
            tips.error(i18n_t('切换失败,请刷新页面后重试'));
          }
          switchOrg(newOrg as SMH.OrgItem);
        } catch (e: any) {
          tips.error(e);
        }
      },
    };
    watch(
      () => selectedProduct.value,
      (newVal, oldVal) => {
        methods.getQrCode();
      },
    );
    watch(successPay, val => {
      if (val) {
        if (!store.getters.teamPay.isNew) {
          methods.closeTeamPay();
          // 续费 刷新页面 到期设置为false
          user.setOrgExpired(false);
          // 考虑到团队续费完成后涉及更新较多 强刷页面
          window.location.reload();
        }
        reporter.report('pay', {
          pay_price: selectedProduct.value.price,
          pay_package: selectedProduct.value.productid,
          pay_id: store.getters.userId,
          pay_source_success: store.getters.paySource,
        });
      }
    });
    watch(
      () => props.show,
      val => {
        if (val) {
          methods.initData();
        } else {
          window.clearInterval(queryOrderTimer);
          queryOrderTimer = undefined;
        }
      },
    );
    store.getters.isInWeMeetApp &&
      meeting.SDK.addEventListener('sidebar-position-changed', methods.onMeetSidebarPositionChange);
    onUnmounted(() => {
      store.getters.isInWeMeetApp && meeting.SDK.removeEventListeners('sidebar-position-changed');
    });
    const goHomePage = () => {
      dispatchRouter(CONSTANT_URL.officialWebsiteUrl);
    };
    return {
      midasH5,
      teamIntroduces,
      products,
      selectedProduct,
      baseInfo,
      successPay,
      qrCodeLoading,
      loading,
      dispatchRouter,
      goHomePage,
      ...methods,
    };
  },
});
